import {
	Button,
	Divider,
	Header,
	Label,
	Message,
	Modal,
	Segment,
} from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import ReactDropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import type { DemandeCompte } from '../../interfaces/demandeCompte';

interface DemandeDeCompteCertificatModalProps {
	demandeCompte: DemandeCompte;
	onClose: () => void;
	onChangeCertificat: (idDemandeCompte: number, certificat: File) => void;
	isLoading?: boolean;
}

const DemandeDeCompteCertificatModal = ({
	demandeCompte,
	onChangeCertificat,
	onClose,
	isLoading,
}: DemandeDeCompteCertificatModalProps) => {
	const [certificat, setCertificat] = React.useState<File | null>(null);

	const handleChangeCertificat = (files: File[]) => {
		setCertificat(files[0]);
	};

	const handleValidate = () => {
		if (certificat) {
			onChangeCertificat(demandeCompte.identifiant, certificat);
		} else {
			toast.error('Veuillez sélectionner un certificat avant de valider.');
		}
	};

	return (
		<Modal onClose={onClose} open>
			<Modal.Header>Changer de certificat</Modal.Header>
			<Modal.Content>
				<Message className="message-replace-user" info>
					<Message.Header>Agent télétransmetteur :</Message.Header>
					<div>
						<strong>Nom: </strong>
						{demandeCompte.prenom} {demandeCompte.nom}
					</div>

					<div>
						<strong>Certificat actuel: </strong>
						{demandeCompte.certificat ? (
							<Label color="green">Valide</Label>
						) : (
							<Label color="red">Aucun certificat</Label>
						)}
					</div>
				</Message>

				<ReactDropzone
					accept={{
						'application/pkix-cert': [],
						'application/x-x509-ca-cert': [],
						'.cer': [],
					}}
					onDrop={handleChangeCertificat}
					multiple={false}
				>
					{({ getRootProps, getInputProps }) => (
						<div {...getRootProps()}>
							<Header textAlign="left">Certificat CER</Header>
							<Segment>
								<input {...getInputProps()} />
								<Icon
									iconSet="Lucide"
									name="FolderUp"
									color={certificat ? 'green' : 'black'}
								/>
								{certificat ? (
									<p>Fichier: {certificat.name}</p>
								) : (
									<p>Déposer ici le certificat CER.</p>
								)}
							</Segment>
						</div>
					)}
				</ReactDropzone>

				<Divider hidden />
				<p>
					Le nouveau certificat remplacera l&apos;ancien et sera vérifié
					automatiquement pour s&apos;assurer qu&apos;il respecte les normes RGS
					*
				</p>
			</Modal.Content>
			<Modal.Actions>
				<Button color="black" onClick={onClose}>
					Annuler
				</Button>
				<Button
					icon="checkmark"
					onClick={handleValidate}
					primary
					loading={isLoading}
				>
					Changer de certificat
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default DemandeDeCompteCertificatModal;
